import React, { useState, useEffect } from "react"
import { Container, Modal, Form, Button } from 'react-bootstrap';
import { navigate } from "@reach/router"
import { removeSpecialChar } from "../../common/site/utils"

import SearchInputBox from '../../predictive-search/search-areas';
import "./SearchBlock.scss"

const SearchBlock = (props) => {
  const [search, setSearch] = useState("manchester") 

  useEffect(() => {

  }, [])

  const submitForm = (isBuy) => {
    let url = ''
    if (!isBuy) {
      url = '/property/to-rent/in-' + search
    } else {
      url = '/property/for-sale/in-' + search
    }
    navigate(url);
  }

  const onSetSearch = (val) => {
    setSearch(removeSpecialChar(val))
  }
  

  return (

    <div className={`banner-search-block`}>
      <Form.Group>
        <div className="search-input">
          <i className="icon-pin"></i>
          {/* <Form.Control type="text" className="postcode_input" placeholder="Street, area or postcode" onChange={(e) => { setSearch(e.target.value) }} /> */}
          <div className="search">
            <SearchInputBox className="postcode_input form-control" onSetSearch={onSetSearch} />
          </div>
        </div>

        <Button type="button" className="btn btn-primary" onClick={() => submitForm(true)} >Buy</Button>
        <Button type="button" className="btn btn-primary" onClick={() => submitForm(false)}>Rent</Button>
      </Form.Group>
    </div>
  )
}

export default SearchBlock
